import DataStore from '../../stores/DataStore';
import { ModelDataUpdate } from '../../Events';
import * as $ from 'jquery';
import 'jquery-match-height';

export function init(tag: any): void {
  tag.on('mount', () => {
    DataStore.addListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.on('unmount', () => {
    DataStore.removeListener(ModelDataUpdate, onModelDataUpdate);
  });
  function onModelDataUpdate(): void {
    const report = DataStore.getReport();
    tag.presentable = report && report.isPresentable;
    tag.update();
  }
  $(function(): void {
    // $('#map-container').matchHeight({
    //   target: $('#ahv-cadastre-display-table'),
    //   property: 'min-height'
    // });
    // $('#map-container').matchHeight({
    //   target: $('#ahv-surrounding-housing-values-table'),
    //   property: 'height'
    // });
    // $('#ahv-surrounding-housing-values-display-header').matchHeight({
    //   target: $('#ahv-map-display-header')
    // });
  });
  tag.on('updated', () => {
    // $.fn.matchHeight._update();
  });
}



/** WEBPACK FOOTER **
 ** ./src/components/housingValueDisplay/HousingValueDisplayController.ts
 **/